import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { AuthContext } from "context/Authentication";
import { ThemeContext } from "context/ThemeContext";
import kartlyLightLogo from "../../assets/media/sAsset 34.png";
import kartlyDarkLogo from "../../assets/media/sAsset 44.png";

export default function CompactFooter() {
  const context = useContext(AuthContext);
  const themeMode = useContext(ThemeContext);
  const theme = useTheme();
  const companyInfo = context.state.companyInfo;
  const darkMode = themeMode.state.darkMode;

  // Get Powered By setting from appSettings
  const poweredBySetting = context.state.appSettings?.find(
    (setting) => setting.Setting_Name === "Powered By"
  );
  const poweredByValue = poweredBySetting?.Setting_Value || "Kartly"; // Default to Kartly

  // Check if it's an AudioBook/Digital Product
  const isAudioBook =
    context.state.companyInfo?.Product_Service_Type === "Product - Digital";
  return (
    <Box
      sx={{
        padding: { xs: "16px 12px", sm: "20px" },
        textAlign: "center",
        background: isAudioBook
          ? darkMode
            ? `linear-gradient(135deg, ${theme.palette.secondary.main}80 0%, ${theme.palette.secondary.main}65 50%, ${theme.palette.secondary.main}50 100%)`
            : `linear-gradient(135deg, ${theme.palette.secondary.main}85 0%, ${theme.palette.secondary.main}70 50%, ${theme.palette.secondary.main}55 100%)`
          : darkMode
          ? "linear-gradient(135deg, rgba(8, 8, 8, 0.9) 0%, rgba(15, 15, 15, 0.85) 50%, rgba(8, 8, 8, 0.8) 100%)"
          : "linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(250, 250, 250, 0.8) 50%, rgba(255, 255, 255, 0.75) 100%)",
        backdropFilter: !isAudioBook ? "blur(8px) saturate(1.8)" : "none",
        border: !isAudioBook
          ? darkMode
            ? "1px solid rgba(255, 255, 255, 0.1)"
            : "1px solid rgba(255, 255, 255, 0.3)"
          : "none",
        boxShadow: !isAudioBook
          ? darkMode
            ? "0 4px 16px rgba(0, 0, 0, 0.3)"
            : "0 4px 16px rgba(0, 0, 0, 0.1)"
          : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        overflow: "hidden",
        minHeight: { xs: "auto", sm: "60px" },
      }}
    >
      {/* Content Layer */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 0 },
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: "12px", sm: "14px" },
            order: { xs: 2, sm: 1 },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          &copy; {1900 + new Date().getYear()}{" "}
          {companyInfo?.Company_Name || "Your Company Name"}. All Rights
          Reserved.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: "12px", sm: "14px" },
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "center", sm: "flex-end" },
            order: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "auto" },
            flexWrap: "wrap",
          }}
        >
          Powered by{" "}
          {poweredByValue === "Brainsie" ? (
            <Button
              variant="link"
              href="https://brainsietech.com"
              target="_blank"
              sx={{
                textTransform: "none",
                padding: 0,
                minWidth: "auto",
                marginLeft: "4px",
                marginRight: "4px",
                color: "inherit",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "none",
                },
              }}
            >
              Brainsie
            </Button>
          ) : (
            <Button
              variant="link"
              href="https://kartly.ai"
              target="_blank"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                textTransform: "none",
                padding: 0,
                minWidth: "auto",
              }}
            >
              <img
                src={darkMode ? kartlyLightLogo : kartlyDarkLogo}
                alt="Kartly Logo"
                style={{ height: "20px", width: "auto", margin: "0 10px" }}
              />
            </Button>
          )}
          v4.0.0.1
        </Typography>
      </Box>
    </Box>
  );
}
